<template>
  <div class="wrapper">
    <div class="wrapper-menu">
      <h4 class="wrapper-menu-list">目录</h4>
      <el-tree
        class="el-tree"
        :data="menData"
        :accordion="true"
        node-key="id"
        ref="tree"
        :default-expanded-keys="defaultExpand"
        :props="defaultProps"
        @node-click="handleNodeClick"
        :highlight-current="true"
        :render-after-expand="false"
      >
        <span class="span-ellipsis" slot-scope="{ node }">
          <span :title="node.label">{{ node.label }}</span>
        </span>
      </el-tree>
    </div>
    <div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
        defaultExpand: [],
        defaultChecked: [],
      menData: [
        {
          id: 1,
          name: "question",
          label: "易招聘初步了解"
        },
        {
          id: 2,
          label: "账号类问题",
          children: [
            {
              id: 50,
              name: "question1",
              label: "员工无法登录易招聘／提示超过套餐人数"
            },
            {
              name: "question2",
              label: "员工离职如何操作？"
            },
            {
              name: "question3",
              label: "人事主管为什么无法看到员工数据？"
            }
          ]
        },
        {
          id: 3,
          label: "招聘管理类问题",
          children: [
            {
              name: "question4",
              label: "候选人来不及面试，如何修改面试时间？"
            },
            {
              name: "question5",
              label: "首次使用招聘管理的操作流程是什么？"
            },
            {
              name: "question6",
              label: "HR如何与面试官无接触协同招聘？"
            },
            {
              name: "question7",
              label: "如何使用应聘登记表？"
            },
            {
              name: "question8",
              label: "HR如何确认面试者已填写完应聘登记表？"
            },
            {
              name: "question9",
              label: "协作者如何参与招聘管理？"
            },
            {
              name: "question10",
              label: "上传简历解析失败是什么原因？"
            },
            {
              name: "question11",
              label: "批量发起背调/批量简历导入"
            },
            {
              name: "question12",
              label: "候选人已经成功入职后如何查看面试记录？"
            },
            {
              name: "question13",
              label: "招聘日历里面的面试记录为什么没有了？"
            },
            {
              name: "question14",
              label: "候选人拒绝了Offer后数据在哪里查看？"
            },
            {
              name: "question15",
              label: "候选人没有收到Offer怎么办？"
            },
            {
              name: "question16",
              label: "候选人如何进行Offer的接收/拒绝？"
            },
            {
              name: "question17",
              label: "Offer以短信形式发送，具有法律效应吗？"
            },
            {
              name: "question18",
              label: "发Offer时候如果出现友情提示怎么办？"
            },
            {
              name: "question19",
              label: "已入职的人员能否删除？"
            },
            {
              name: "question40",
              label: "修改招聘岗位名称后，岗位名称会同步到历史信息吗？"
            },
            {
              name: "question41",
              label: "信息已读未读具体指什么？"
            }
          ]
        },
        {
          id: 4,
          label: "背调类问题",
          children: [
            {
              name: "question20",
              label: "为什么背调成功后无法开发票？"
            },
            {
              name: "question21",
              label: "背调之后多久出报告？"
            },
            {
              name: "question22",
              label: "背调授权是否有有效期？"
            },
            {
              name: "question23",
              label: "候选人不授权，支付的钱会退款吗？"
            },
            {
              name: "question24",
              label: "背调的数据权威吗？"
            },
            {
              name: "question25",
              label: "为什么提示背调失败？"
            },
            {
              name: "question26",
              label: "未用完的余额可以提现吗？"
            },
            {
              name: "question27",
              label: "账号中心充值，最低充值费用是多少？"
            },
            {
              name: "question28",
              label: "授权人忘记授权，每天可以催授权几次？"
            }
          ]
        },
        {
          id: 5,
          label: "组织权限类问题",
          children: [
            // {
            //     name:'question29',
            //     label:'为什么公司里的所有人都可以使用易招聘？'
            // },
            {
              name: "question30",
              label: "为什么打开易招聘提示暂无权限？"
            },
            {
              name: "question31",
              label: "二级权限是什么？"
            },
            {
              name: "question32",
              label: "一级权限的是什么？"
            }
          ]
        },
        {
          id: 6,
          label: "短信类问题",
          children: [
            {
              name: "question33",
              label: "面试者会有收不到短信的可能吗？"
            }
            // ,
            // {
            //     name:'question34',
            //     label:'短信发出链接有有效期吗？'
            // }问题已删除
          ]
        },
        {
          id: 7,
          label: "账户中心",
          children: [
            // {
            //     name:'question35',
            //     label:'续费与发票申请咨询'
            // },
            // {
            //     name:'question36',
            //     label:'易招聘套餐报价'
            // },
            // {
            //     name:'question37',
            //     label:'增值背调套餐报价'
            // }, //删除的问题
            // {
            //     name:'question38',
            //     label:'如何账户充值与发票申请？'
            // },
            {
              name: "question39",
              label: "如何保障服务？"
            }
          ]
        },
        {
          id: 8,
          label: "邮箱代收教程",
          children: [
            {
              id: 44,
              name: "question44",
              label: "腾讯邮箱"
            },
            {
              id: 43,
              name: "question43",
              label: "网易邮箱"
            },
            {
              id: 42,
              name: "question42",
              label: "新浪邮箱"
            },
            {
              id: 45,
              name: "question45",
              label: "搜狐邮箱"
            },
            {
              id: 46,
              name: "question46",
              label: "谷歌邮箱"
            }
          ]
        }
      ],
      defaultProps: {
        children: "children",
        label: "label"
      }
    };
  },
  watch: {},
  methods: {
    handleNodeClick(data) {
      if (data.name) {
        this.$router.push(data.name);
      }
    },
  },
  mounted() {
      let name = this.$route.name
      if( name == 'question44' || name == 'question43' || name == 'question42' || name == 'question45') {
          this.defaultExpand.push(8)
      }
    this.$store.dispatch("first_nav_change", "9-1");
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/problem.vue